<template>
  <el-button
    class="page-back-btn"
    icon="el-icon-back"
    @click="$emit('click', $event)"
  >
    <slot>返回列表</slot>
  </el-button>
</template>

<script>
export default {
  name: 'PageBack'
}
</script>
